export function getDisplayName<TProps extends object>(
  component: React.ComponentType<TProps>,
  defaultName = 'Component',
) {
  return component.displayName || component.name || defaultName;
}
